
export default {
  'Login': 'Iniciar sesión',
  'Register': 'Registrarse',
  'Logout': 'Cerrar sesión',
  'Email': 'Correo electrónico',
  'Password': 'Contraseña',
  'Confirm Password': 'Confirmar contraseña',
  'Forgot password?': '¿Olvidaste tu contraseña?',
  'Don\'t have an account?': '¿No tienes una cuenta?',
  'Already have an account?': '¿Ya tienes una cuenta?',
  'Sign up': 'Registrarse',
  'Sign in': 'Iniciar sesión',
  'Create Account': 'Crear cuenta',
  'Join Now': 'Únete ahora',
  'Your email address': 'Tu correo electrónico',
  'Your password': 'Tu contraseña',
  'Remember me': 'Recordarme',
  'Enter your email': 'Introduce tu correo electrónico',
  'Enter your password': 'Introduce tu contraseña',
  'Seedphrase': 'Frase semilla',
  'Create a seedphrase for anonymous login': 'Crea una frase semilla para inicio de sesión anónimo',
  'Login with Seedphrase': 'Iniciar sesión con frase semilla',
  'Enter at least 6 words separated by spaces': 'Ingresa al menos 6 palabras separadas por espacios',
  'Use seedphrase instead of password': 'Usar frase semilla en lugar de contraseña',
  'Your seedphrase has been created': 'Tu frase semilla ha sido creada. Por favor, guárdala en un lugar seguro.',
  'Seedphrase must contain at least 6 words': 'La frase semilla debe contener al menos 6 palabras',
  'Name': 'Nombre',
  'Your name': 'Tu nombre',
  'Create Anonymous Account': 'Crear cuenta anónima',
  'Login Anonymously': 'Iniciar sesión anónimamente',
  'Email & Password': 'Email y contraseña',
  'Anonymous (Seedphrase)': 'Anónimo (Frase semilla)',
  'Create an account with your email': 'Crea una cuenta con tu email',
  'Create an anonymous account with a seedphrase': 'Crea una cuenta anónima con una frase semilla',
  'Sign in to your account': 'Inicia sesión en tu cuenta',
  'Create your account': 'Crea tu cuenta',
  'Confirm your password': 'Confirma tu contraseña',
  'I agree to the': 'Estoy de acuerdo con los',
  'Terms of Service': 'Términos de servicio',
  'and': 'y',
  'Privacy Policy': 'Política de privacidad',
  'Loading...': 'Cargando...',
  'Reset your password': 'Restablecer tu contraseña',
  'Enter your email address and we\'ll send you a link to reset your password.': 'Introduce tu correo electrónico y te enviaremos un enlace para restablecer tu contraseña.',
  'Send reset link': 'Enviar enlace de restablecimiento',
  'Cancel': 'Cancelar',
  'Sending...': 'Enviando...',
  'Account type': 'Tipo de cuenta',
  'Client': 'Cliente',
  'Escort': 'Escort',
  'Select your account type': 'Selecciona tu tipo de cuenta',
  'Choose your role': 'Elige tu rol'
};
